module.exports = __webpack_public_path__ + "static/Spain-Step1-da042b6c452b208d0c856e83e9f52829.png";